import { Button, Heading, LuIcon, Text } from "@overmap-ai/blocks"
import { memo, useCallback } from "react"
import type { DateRange } from "react-day-picker"

import { modelIconMapping } from "../../../mappings/icons"
import { setGeoImageDateRange, useAppDispatch, useAppSelector } from "../../../store"
import { selectGeoImageDateRange } from "../../../store/selectors"
import { formatDateRange } from "../../../utils/date"
import { DayPickerPopover } from "../../Popovers/DayPickerPopover"

export const GeoImagesVisibilityTab = memo(() => {
	const geoImageDateRange = useAppSelector(selectGeoImageDateRange)
	const dispatch = useAppDispatch()

	const handleSetGeoImageDateRange = useCallback(
		(dateRange: DateRange | undefined) => {
			dispatch(setGeoImageDateRange(dateRange ?? null))
		},
		[dispatch],
	)

	return (
		<div className="flex w-full flex-col gap-2 overflow-y-auto">
			<div className="flex flex-col gap-1">
				<div className="flex w-full items-center justify-between">
					<Heading>Images</Heading>
				</div>
			</div>
			<div className="flex flex-col gap-2">
				<Text size="sm" accentColor="base">
					Filter images by the date they were taken. This will only show images that were taken within the
					selected range.
				</Text>
				<DayPickerPopover
					mode="range"
					required={false}
					selected={geoImageDateRange ?? undefined}
					onSelect={handleSetGeoImageDateRange}
					variant="solid"
					align="end"
					size="sm"
				>
					<Button className="w-max" variant="soft" size="sm" accentColor="base">
						<LuIcon icon={modelIconMapping.dueDate} />
						{geoImageDateRange ? formatDateRange(geoImageDateRange) : "Filter"}
					</Button>
				</DayPickerPopover>
			</div>
		</div>
	)
})
GeoImagesVisibilityTab.displayName = "GeoImagesVisibilityTab"
